// @ts-nocheck
import React from 'react';
import { NavLink } from 'react-router-dom';

export default function BottomTabs() {
  const link = (to: string, label: string, icon: string) => (
    <NavLink
      to={to}
      className={({isActive}) => `flex-1 flex flex-col items-center justify-center py-2 ${isActive ? 'text-blue-600' : 'text-gray-500'}`}
    >
      <span className="text-xl">{icon}</span>
      <span className="text-xs">{label}</span>
    </NavLink>
  );
  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 border-t bg-white/95 dark:bg-gray-900/95 backdrop-blur z-40 flex">
      {link('/', 'Descubrir', '🏠')}
      {link('/map', 'Mapa', '🗺️')}
      {link('/lists', 'Listas', '📚')}
      {link('/profile', 'Perfil', '👤')}
    </nav>
  );
}
